import React from 'react';

import { cn } from '@lyearn/style';
import { Box, Typography } from '@lyearn/ui';

import { QuestionsProps } from './types';

function Questions(props: QuestionsProps) {
  const { Icon, text, textColor = 'text-text-primary' } = props;

  return (
    <Box
      className={cn(
        'flex h-40 w-max items-center justify-center rounded-8 border border-interactive-secondary ps-8 pe-12 flex-row',
      )}>
      <Icon className="h-20 w-20 me-8" fillColorToken="icon-primary" />
      <Typography className="whitespace-pre" color={textColor} variant="body-short-02">
        {text}
      </Typography>
    </Box>
  );
}

export default React.memo(Questions);
